import './PageNotFound.scss';

const PageNotFound = () => {
    return (
        <section className='page-not-found'>
            <h1 className='page-not-found__title'>Page Not Found</h1>
            <p className='page-not-found__text'>Sorry, but ain't shit here.</p>

        </section>
    )
}

export default PageNotFound
